import { render, staticRenderFns } from "./RegisterCompany.vue?vue&type=template&id=3ef0aeb2&"
import script from "./RegisterCompany.vue?vue&type=script&lang=js&"
export * from "./RegisterCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports